export default __webpack_public_path__ + "static/media/cardio.89a0a588.jpg";